import {
  ConversationChannel,
  type TCSearcherTimelineItemDocument,
} from 'src/api/generated';
import { isMessageItem } from './item-type-guards.util';
import type { TimelineRow } from '../../types/timeline/compact-timeline.types';

/**
 * Assigns visual message runs without combining, re-keying or hiding events.
 * Delivery status, content length and optimistic IDs cannot split a run.
 * @param items - Chronologically ordered events within one date.
 * @returns One row per input event, preserving its identity and order.
 */
export const getTimelineRows = (
  items: TCSearcherTimelineItemDocument[]
): TimelineRow[] =>
  items.map((item, index) => {
    const previous = items.at(index - 1);
    const isContinuation = Boolean(
      index > 0 &&
        previous &&
        isMessageItem(item) &&
        isMessageItem(previous) &&
        item.channel === ConversationChannel.WHATSAPP &&
        previous.channel === item.channel &&
        item.direction === previous.direction &&
        item.userId === previous.userId &&
        item.sender.address === previous.sender.address &&
        item.sender.providerId === previous.sender.providerId &&
        item.recipient?.address === previous.recipient?.address &&
        item.recipient?.providerId === previous.recipient?.providerId &&
        item.conversationId === previous.conversationId &&
        item.funnelConversationId === previous.funnelConversationId &&
        item.funnelId === previous.funnelId &&
        Math.abs(
          new Date(item.createdAt).getTime() -
            new Date(previous.createdAt).getTime()
        ) <= 120000
    );
    return { item, isContinuation };
  });
